module.exports = __webpack_public_path__ + "img/get-the-code.a8c7506e.svg";